import React, { useEffect, useState } from "react";
import axios from "axios";
import "./CommentManagementPage.css";

const CommentManagementPage = () => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const fetchComments = async (pageNumber = 1) => {
    try {
      setLoading(true);
      const response = await axios.get(`https://api.goharesadaf.ir/api/admin/comments?page=${pageNumber}`);
      setComments(response.data.data);
      setPage(response.data.current_page);
      setLastPage(response.data.last_page);
    } catch (err) {
      console.error(err);
      setError("خطا در بارگذاری کامنت‌ها");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchComments();
  }, []);

  const toggleState = async (commentId, currentState) => {
    try {
      const newState = currentState === "shown" ? "hidden" : "shown";
      await axios.patch(`https://api.goharesadaf.ir/api/admin/comments/${commentId}/state`, { state: newState });
      setComments((prev) =>
        prev.map((c) => (c.id === commentId ? { ...c, state: newState } : c))
      );
    } catch (err) {
      console.error(err);
      alert("خطا در تغییر وضعیت کامنت");
    }
  };

  const deleteComment = async (commentId) => {
    if (!window.confirm("آیا از حذف این کامنت مطمئن هستید؟")) return;
    try {
      await axios.delete(`https://api.goharesadaf.ir/api/admin/comments/${commentId}`);
      setComments((prev) => prev.filter((c) => c.id !== commentId));
    } catch (err) {
      console.error(err);
      alert("خطا در حذف کامنت");
    }
  };

  const handlePrevPage = () => {
    if (page > 1) fetchComments(page - 1);
  };

  const handleNextPage = () => {
    if (page < lastPage) fetchComments(page + 1);
  };

  if (loading) return <div className="loading">در حال بارگذاری...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="comment-management-page">
      <h2>مدیریت کامنت‌ها</h2>
      <table className="comments-table">
        <thead>
          <tr>
            <th>کاربر</th>
            <th>کامنت</th>
            <th>امتیاز</th>
            <th>وضعیت</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {comments.map((comment) => (
            <tr key={comment.id}>
              <td>{comment.user?.name ?? "کاربر ناشناس"}</td>
              <td className="comment-content">{comment.content}</td>
              <td>{comment.rating ?? "-"}</td>
              <td>
                <button
                  className={`state-btn ${comment.state}`}
                  onClick={() => toggleState(comment.id, comment.state)}
                >
                  {comment.state === "shown" ? "نمایش داده شود" : "مخفی"}
                </button>
              </td>
              <td>
                <button
                  className="delete-btn"
                  onClick={() => deleteComment(comment.id)}
                >
                  حذف
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination">
        <button disabled={page <= 1} onClick={handlePrevPage}>
          قبلی
        </button>
        <span>{page} / {lastPage}</span>
        <button disabled={page >= lastPage} onClick={handleNextPage}>
          بعدی
        </button>
      </div>
    </div>
  );
};

export default CommentManagementPage;
